// Referral physicians directory (owner item 3, 2026-10-19). These routes exist
// only on the v2 gateway (api/referralphysicians), so they go through
// careiqapi (straight to v2, same token) rather than api.js's v1/v2 routing.
// careiqapi resolves to the response body: {status, message, data}.
import careiqapi from "../../api/careiqapi";
import { getPracticeId } from "../../config/practice";

const base = () => `/v1/${getPracticeId()}/referral-physicians`;

// {enabled, can_add, can_manage, specialties, credentials}, or a closed answer
// when v2 cannot be reached (the picker then works exactly as before).
export const CLOSED_ACCESS = Object.freeze({ enabled: false, can_add: false, can_manage: false, specialties: [], credentials: [] });

export async function fetchAccess() {
  try {
    const body = await careiqapi.get(`${base()}/access`);
    return { ...CLOSED_ACCESS, ...(body && body.data ? body.data : {}) };
  } catch (e) {
    return CLOSED_ACCESS;
  }
}

export async function searchPhysicians(q, { includeInactive = false, limit = 25 } = {}) {
  const body = await careiqapi.get(base(), { params: { q: q || "", include_inactive: includeInactive ? 1 : 0, limit } });
  return Array.isArray(body && body.data) ? body.data : [];
}

export const createPhysician = (payload) => careiqapi.post(base(), payload);

export const updatePhysician = (id, payload) => careiqapi.patch(`${base()}/${id}`, payload);

export const setPhysicianActive = (id, active) =>
  careiqapi.post(`${base()}/${id}/${active ? "reactivate" : "deactivate"}`, {});
